export default function Finish(props){
    return (
        <div>
            <h1>恭喜您</h1>
            <h1>完成了此次练习</h1>
        </div>
    )
}